import { render } from "./SeriesOptions.vue?vue&type=template&id=12bc5416"
import script from "./SeriesOptions.vue?vue&type=script&lang=js"
export * from "./SeriesOptions.vue?vue&type=script&lang=js"

import exportComponent from "/vercel/path0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__